import React from "react";
import { useSelector } from "react-redux";
import moment from "moment";
import "./style.css";

function Notification({ item }) {
  const user = useSelector((state) => state.root.user);
  return (
    <div className="main_container">
      <div className="notify_container">
        {item?.type === 1 && (
          <>
            <p className="simple_text mr-1">{"The book "}</p>
            <p className="bold_text mr-1">
              {item?.offeredBook?.library?.bookname}
            </p>
            <p className="simple_text mr-1">
              {" is no longer available for swap."}
            </p>
          </>
        )}
        {item?.type === 2 && (
          <>
            <p className="bold_text mr-1">@{item?.offeredUser?.username}</p>
            <p className="simple_text mr-1">
              {" accepted your offer to swap "}
            </p>
            <p className="bold_text mr-1">
              {item?.offeredBook?.library?.bookname}
            </p>
            <p className="simple_text mr-1">{" with "}</p>
            <p className="bold_text mr-1">
              {item?.offeringBook?.library?.bookname}
            </p>
            <p className="simple_text">{"."}</p>
          </>
        )}
        {item?.type === 3 && (
          <>
            <p className="bold_text mr-1">@{item?.offeredUser?.username}</p>
            <p className="simple_text mr-1">{" bought your book "}</p>
            <p className="bold_text mr-1">
              {item?.offeredBook?.library?.bookname}
            </p>
            <p className="simple_text mr-1">
              {". The remaining number of copies are "}
            </p>
            <p className="bold_text mr-1">
              {item?.offeredBook?.library?.remainingCopies}
            </p>
            <p className="simple_text">{"."}</p>
          </>
        )}
        {item?.type === 4 && (
          <>
            <p className="bold_text mr-1">@{item?.offeredUser?.username}</p>
            <p className="simple_text mr-1">{" made an offer to swap "}</p>
            <p className="bold_text mr-1">
              {item?.offeringBook?.library?.bookname}
            </p>
            <p className="simple_text mr-1">{" with "}</p>
            <p className="bold_text mr-1">
              {item?.offeredBook?.library?.bookname}
            </p>
            <p className="simple_text mr-1">{"."}</p>
          </>
        )}
        {item?.type === 5 && (
          <>
            <p className="bold_text mr-1">@{item?.offeredUser?.username}</p>
            <p className="simple_text mr-1">{"rejected your offer to swap "}</p>
            <p className="bold_text mr-1">
              {item?.offeredBook?.library?.bookname}
            </p>
            <p className="simple_text mr-1">{" with "}</p>
            <p className="bold_text">{item?.offeringBook?.library?.bookname}</p>
            <p className="simple_text">{"."}</p>
          </>
        )}

        <p className="minutes_text">{moment(item?.createdAt).fromNow()}</p>
      </div>
      <div className="divider" />
    </div>
  );
}

export default Notification;
